import { ProgressBar } from "cdhs-ui-library";
import styles from "./survey.module.scss";
import Question from "../../components/Question/Question";
import { useAppSelector } from "../../store/store";
import { useTranslations } from "../../contexts/LanguageContext";

function Survey() {
  const t = useTranslations();
  const question = useAppSelector((state) => state.survey.survey);
  const user = useAppSelector((state) => state.user.user); // user might be used to get total amount of questions based on Survey Type
  const partial = Number(question?.IndexOfQuestion);
console.log("QUESTION", question)
  return (
    <div className={styles.overlay}>
      <div className={styles.mainContainer}>
      {user ?
      <>
        <ProgressBar showLabel="none" total={question?.TotalNoQuestions ?? 18} partial={partial} variant="NYTD" />
         <Question {...question} /> 
      </>
         : <h1>{t('surveyPage_PleaseLogin', "Please Log in")}</h1> }
      </div>
    </div>
  );
}

export default Survey;
